module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/Remove.17202c1a.svg";